
<v-card outlined elevation="2" :height="getCardHeight" width="52px" style="border-radius: 6px !important" :color="card_color ? card_color : '#E6E6E6'">
	<v-system-bar :color="color ? color : 'gray'" height="12px">
		<v-row>
			<v-col cols="3" class="pl-2 pr-0 pt-1 pb-0">
				<v-avatar min-width="4px" max-width="4px" height="4px" color="white" rounded></v-avatar>
			</v-col>
			<v-col cols="6" class="pl-1 pr-1 pt-2 pb-2" style="font-family: Montserrat; font-style: normal; color: #fff; font-size: 8px; line-height: 7px; text-align: center">
				{{ month }}
			</v-col>
			<v-col cols="3" class="pl-0 pr-2 pt-1 pb-0">
				<v-avatar min-width="4px" max-width="4px" height="4px" color="white" rounded></v-avatar>
			</v-col>
		</v-row>
	</v-system-bar>

	<v-row class="pt-3">
		<v-col class="pt-1 pb-0 mb-0" cols="12" style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 12px; line-height: 7px; text-align: center">
			<span :style="{ color: card_text_color ? card_text_color : '' }">{{ dayOfWeek }}</span>
		</v-col>
	</v-row>
	<div style="display: flex; flex-wrap: wrap; flex: 1 1 auto; margin: -12px">
		<v-col
			class="pt-3 mt-0 pb-1 mb-1"
			cols="12"
			style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 22px; line-height: 29px; text-align: center"
		>
			<span :style="{ color: card_text_color ? card_text_color : '' }">{{ day }}</span>
		</v-col>
	</div>
	<v-row v-if="start_time && end_time" class="ma-auto">
		<span class="text-caption" style="line-height: 0.9rem !important">{{ start_time }} - {{ end_time }}</span>
	</v-row>
</v-card>
